import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, MapPin, GraduationCap, Layers } from 'lucide-react';
import { Button } from '../ui/button';

const STATS = [
  { value: 'K–8', label: 'Grades Served', icon: GraduationCap },
  { value: '40+', label: 'Courses', icon: BookOpen },
  { value: '4', label: 'Locations', icon: MapPin },
  { value: '5', label: 'STEM Pillars', icon: Layers },
];

export default function SummerCampsOffSeasonHero() {
  return (
    <section
      id="summer-camps-hero"
      className="relative overflow-hidden font-poppins"
      data-testid="summer-camps-hero"
    >
      {/* Background — same photo as active season but with a stronger overlay */}
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet="https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782235446/ChatGPT_Image_Jun_22_2026_10_55_49_AM_xtulzz.jpg"
        />
        <img
          src="https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782163164/ChatGPT_Image_Jun_22_2026_10_55_49_AM_tun5pl.png"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-br from-[#0e1a3a]/90 via-[#142554]/88 to-[#0c1733]/90 pointer-events-none" />
      <span aria-hidden className="absolute top-12 -left-10 w-72 h-72 rounded-full bg-rsc-yellow/15 blur-3xl pointer-events-none" />

      <div className="relative container-app py-16 lg:py-24">
        <div className="max-w-3xl">
          {/* Closed season badge */}
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-400/20 border border-amber-400/40 text-amber-300 text-xs font-bold mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            Summer 2026 registration closed
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
            5 STEM Pillars.{' '}
            <span className="text-rsc-yellow">All School Year.</span>
          </h1>

          <p className="text-lg text-white/70 max-w-xl mb-8">
            Summer camp season has wrapped. Our after-school programs run at
            partner schools all year — find a course near you for Fall 2026.
          </p>

          {/* Stats row */}
          <div className="flex flex-wrap gap-4 mb-10">
            {STATS.map(({ value, label, icon: Icon }) => (
              <div key={label} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2.5 border border-white/15">
                <Icon className="h-4 w-4 text-rsc-yellow flex-shrink-0" />
                <div>
                  <span className="text-white font-extrabold text-lg leading-none">{value}</span>
                  <p className="text-white/60 text-xs leading-none mt-0.5">{label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3">
            <Button asChild size="lg" className="bg-rsc-yellow text-rsc-navy font-extrabold hover:bg-rsc-yellow/90">
              <Link to="/catalog">
                Browse Fall Courses <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white/30 text-white hover:bg-white/10 hover:text-white">
              <a href="#summer-interest">
                Get Summer 2027 Updates
              </a>
            </Button>
          </div>
        </div>

        {/* After-school routing card */}
        <div className="mt-10 max-w-sm bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 p-5">
          <p className="text-white/60 text-xs uppercase tracking-widest font-bold mb-1">Looking for after-school?</p>
          <p className="text-white font-bold text-lg leading-snug mb-3">
            Our STEM programs run at your school, every week.
          </p>
          <Link
            to="/catalog"
            className="inline-flex items-center gap-1.5 text-rsc-yellow font-bold text-sm hover:gap-2.5 transition-all"
          >
            Find after-school courses <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
